import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeSubjectService {
  constructor() {}
  fetchSetupData: BehaviorSubject<any> = new BehaviorSubject(null);
  closeSetupItemCard: BehaviorSubject<any> = new BehaviorSubject(null);

  fetchDiscoverySetupData: BehaviorSubject<any> = new BehaviorSubject(null);
  closeDiscoverySetupData: BehaviorSubject<any> = new BehaviorSubject(null);

  private fetchMainSideNav = new BehaviorSubject<any>(false);
  fetchMainSideNav$ = this.fetchMainSideNav.asObservable();

  private fetchDiscoveryClosed = new BehaviorSubject<any>(false);
  fetchDiscoveryClosed$ = this.fetchDiscoveryClosed.asObservable();

  private fetchChatBoxLoaded = new BehaviorSubject<any>(false);
  fetchChatBoxLoaded$ = this.fetchChatBoxLoaded.asObservable();

  private fetchChatBoxOpenState = new BehaviorSubject<any>(false);
  fetchChatBoxOpenState$ = this.fetchChatBoxOpenState.asObservable();

  refreshActionComponent = new BehaviorSubject<any>(false);

  private fetchWorkspaceOpenState = new BehaviorSubject<any>(false);
  fetchWorkspaceOpenState$ = this.fetchWorkspaceOpenState.asObservable();

  handleFetchChatBoxOpenState(val: any) {
    this.fetchChatBoxOpenState.next(val);
  }

  handleFetchChatBoxLoaded(val: any) {
    this.fetchChatBoxLoaded.next(val);
  }

  handleFetchMainSideNav(val: any) {
    this.fetchMainSideNav.next(val);
  }

  handleFetchDiscoveryClosed(val: any) {
    this.fetchDiscoveryClosed.next(val);
  }

  handleFetchSetupData(type: any) {
    this.fetchSetupData.next(type);
  }

  handleCloseSetupItemCard(val: any) {
    this.closeSetupItemCard.next(val);
  }

  handleFetchDiscoverySetupData(type: any) {
    this.fetchDiscoverySetupData.next(type);
  }

  handleCloseDiscoverySetupData(val: any) {
    this.closeDiscoverySetupData.next(val);
  }

  handleRefreshActionComponent(value) {
    this.refreshActionComponent.next(value);
  }

  handleFetchWorkspaceOpenState(val: any) {
    this.fetchWorkspaceOpenState.next(val);
  }
}
